/** JSON metnini çözer; geçersizse undefined döner. */
export function tryParseJson(text: string): any {
  try {
    return JSON.parse(text);
  } catch {
    return undefined;
  }
}

export interface PosDocument {
  typeName?: string;
  invoiceNo?: string;
  /** Belgenin evrensel kimliği (ETTN). */
  documentNo?: string;
}

export interface PosDocuments {
  documents: PosDocument[];
  /** Sağlayıcının satışı ve belgesini gösteren sayfası (Pavo: SaleInquieryLink). */
  viewUrl: string | null;
}

/**
 * Cihaz cevabındaki mali belgeler ve görüntüleme bağlantısı (Pavo terminal cevabı:
 * Data.FinancialDocuments, Data.SaleInquieryLink — alan adı sağlayıcıda bu yazımla geliyor).
 * Gömülü JSON'lar açılarak aranır; cihaza giden istek ("Request") atlanır.
 */
export function extractPosDocuments(responseJson?: string | null): PosDocuments {
  const result: PosDocuments = { documents: [], viewUrl: null };
  const visit = (node: any): void => {
    node = unwrapJson(node);
    if (!node || typeof node !== 'object') return;
    if (Array.isArray(node)) { node.forEach(visit); return; }
    for (const [key, raw] of Object.entries(node)) {
      if (key === 'Request') continue;
      const value = unwrapJson(raw);
      if (key === 'FinancialDocuments' && Array.isArray(value) && !result.documents.length) {
        result.documents = value.map(unwrapJson).filter(d => d && typeof d === 'object').map(d => ({
          typeName: unwrapJson(d.Type)?.Name ?? undefined,
          invoiceNo: d.InvoiceNo || undefined,
          documentNo: d.DocumentNo || undefined,
        }));
      } else if ((key === 'SaleInquieryLink' || key === 'SaleInquiryLink') && typeof value === 'string' && value && !result.viewUrl) {
        result.viewUrl = /^https?:\/\//i.test(value) ? value : `https://${value}`;
      } else {
        visit(value);
      }
    }
  };
  if (responseJson) visit(tryParseJson(responseJson));
  return result;
}

/**
 * Sağlayıcının metin içine gömdüğü JSON nesnesi/dizisi (Pavo link Request/Response, terminal
 * Data) açılır; diğer değerler olduğu gibi döner.
 */
export function unwrapJson(value: any): any {
  if (typeof value !== 'string') return value;
  const text = value.trim();
  if (!(text.startsWith('{') || text.startsWith('['))) return value;
  const parsed = tryParseJson(text);
  return parsed === undefined ? value : parsed;
}
